import { render, staticRenderFns } from "./EditReception.vue?vue&type=template&id=e574938a&scoped=true"
import script from "./EditReception.vue?vue&type=script&lang=js"
export * from "./EditReception.vue?vue&type=script&lang=js"
import style0 from "./EditReception.vue?vue&type=style&index=0&id=e574938a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e574938a",
  null
  
)

export default component.exports